module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-metals.58406d11.png";